export default __webpack_public_path__ + "static/media/Group-chat.29eb56b5.svg";